export const i18n = {
  "favorites_title": "favorites_title",
  "favorites_empty": "favorites_empty",
  "favorites_hidden_guests": "favorites_hidden_guests",
  "favorites_premium_required": "favorites_premium_required",
  "favorites": {
    "warning_inactive": "favorites.warning_inactive",
    "warning_registered": "favorites.warning_registered"
  },
  "privacy_settings": "privacy_settings",
  "private_messages_privacy": "private_messages_privacy",
  "privacy_allow_all": "privacy_allow_all",
  "privacy_favorites_only": "privacy_favorites_only",
  "privacy_disabled": "privacy_disabled",
  "private_messages_reset_notification": "private_messages_reset_notification",
  "add_favorite_guest_warning_title": "add_favorite_guest_warning_title",
  "add_favorite_guest_warning_body": "add_favorite_guest_warning_body",
  "understand_and_add": "understand_and_add",
  "add_to_favorites": "add_to_favorites",
  "remove_from_favorites": "remove_from_favorites",
  "keep_in_favorites": "keep_in_favorites",
  "favorite_warning": "favorite_warning",
  "favorite_user": "favorite_user",
  "favorites_limit_exceeded": "favorites_limit_exceeded",
  "favorites_guest_requires_premium": "favorites_guest_requires_premium",
  "favorites_already_exists": "favorites_already_exists",
  "favorites_cannot_add_self": "favorites_cannot_add_self",
  "favorites_only_for_registered": "favorites_only_for_registered",
  "chat_title": "chat_title",
  "partners_title": "partners_title",
  "login_title": "login_title",
  "chat_long_title": "chat_long_title",
  "site_description": "site_description",
  "site_keywords": "site_keywords",
  "yes_change_region": "yes_change_region",
  "no_dont_touch_region": "no_dont_touch_region",
  "registration_confirmation": "registration_confirmation",
  "email_confirmed": "email_confirmed",
  "link_is_wrong": "link_is_wrong",
  "email_confirmation": "email_confirmation",
  "registration": "registration",
  "create_a_nickname": "create_a_nickname",
  "nickname_is_busy": "nickname_is_busy",
  "access_restoration": "access_restoration",
  "create_a_password": "create_a_password",
  "hide_show_password": "hide_show_password",
  "fill_in_a_password": "fill_in_a_password",
  "password_to_long": "password_to_long",
  "password_to_short": "password_to_short",
  "password_only_from_digits": "password_only_from_digits",
  "repeat_the_password": "repeat_the_password",
  "wrong_password": "wrong_password",
  "password_not_equals": "password_not_equals",
  "legal_age_confirmation": "legal_age_confirmation",
  "confirmation_required": "confirmation_required",
  "confirmation_rules_1": "confirmation_rules_1",
  "confirmation_rules_2": "confirmation_rules_2",
  "confirmation_rules_3": "confirmation_rules_3",
  "register": "register",
  "continue": "continue",
  "home": "home",
  "access_restored_you_can_enter_with_new_password": "access_restored_you_can_enter_with_new_password",
  "entrance": "entrance",
  "registration_complete": "registration_complete",
  "access_restoration_step_2": "access_restoration_step_2",
  "access_restoration_step_1": "access_restoration_step_1",
  "email_with_confirmation_link_will_be_send": "email_with_confirmation_link_will_be_send",
  "email_has_already_registered": "email_has_already_registered",
  "email_is_incorrect": "email_is_incorrect",
  "repeat_email": "repeat_email",
  "you_should_solve_a_captcha": "you_should_solve_a_captcha",
  "region": "region",
  "region_description": "region_description",
  "close": "close",
  "check_internet_connection_and_try_again": "check_internet_connection_and_try_again",
  "email_instruction": "email_instruction",
  "to_contact_the_administration_write_to_email": "to_contact_the_administration_write_to_email",
  "current_email": "current_email",
  "contacts": "contacts",
  "qa": "qa",
  "site_only_for_adult_footer": "site_only_for_adult_footer",
  "site_only_for_adult_footer_rules": "site_only_for_adult_footer_rules",
  "site_only_for_adult_footer_and": "site_only_for_adult_footer_and",
  "site_only_for_adult_footer_privacy_policy": "site_only_for_adult_footer_privacy_policy",
  "home_text": "home_text",
  "rules_title": "rules_title",
  "rules_header": "rules_header",
  "rules_p1_1": "rules_p1_1",
  "rules_p1_2": "rules_p1_2",
  "rules_p2": "rules_p2",
  "rules_p3": "rules_p3",
  "rules_p4": "rules_p4",
  "rules_p5": "rules_p5",
  "rules_p6": "rules_p6",
  "rules_p7": "rules_p7",
  "rules_p8": "rules_p8",
  "rules_p9": "rules_p9",
  "rules_p10_1": "rules_p10_1",
  "rules_p10_2": "rules_p10_2",
  "rules_p11": "rules_p11",
  "rules_p12": "rules_p12",
  "rules_p13": "rules_p13",
  "rules_p14": "rules_p14",
  "rules_p14_1": "rules_p14_1",
  "rules_p15": "rules_p15",
  "rules_p16": "rules_p16",
  "rules_p17": "rules_p17",
  "rules_p18": "rules_p18",
  "rules_p19": "rules_p19",
  "rules_p20": "rules_p20",
  "rules_p21": "rules_p21",
  "rules_p22": "rules_p22",
  "rules_p23": "rules_p23",
  "rules_p24": "rules_p24",
  "rules_p25": "rules_p25",
  "rules_p26": "rules_p26",
  "rules_p27": "rules_p27",
  "rules_p28": "rules_p28",
  "rules_p29": "rules_p29",
  "rules_p30": "rules_p30",
  "rules_p31_1": "rules_p31_1",
  "rules_p31_2": "rules_p31_2",
  "privacy_policy": "privacy_policy",
  "privacy_policy_for_site": "privacy_policy_for_site",
  "privacy_policy_h3_1": "privacy_policy_h3_1",
  "privacy_policy_p1": "privacy_policy_p1",
  "privacy_policy_h3_2": "privacy_policy_h3_2",
  "privacy_policy_p2": "privacy_policy_p2",
  "privacy_policy_ul1_1": "privacy_policy_ul1_1",
  "privacy_policy_ul1_2": "privacy_policy_ul1_2",
  "privacy_policy_ul1_3": "privacy_policy_ul1_3",
  "privacy_policy_ul1_4": "privacy_policy_ul1_4",
  "privacy_policy_ul1_5": "privacy_policy_ul1_5",
  "privacy_policy_ul1_6": "privacy_policy_ul1_6",
  "privacy_policy_p3": "privacy_policy_p3",
  "privacy_policy_h3_3": "privacy_policy_h3_3",
  "privacy_policy_p4": "privacy_policy_p4",
  "privacy_policy_ul2_1": "privacy_policy_ul2_1",
  "privacy_policy_ul2_2": "privacy_policy_ul2_2",
  "privacy_policy_ul2_3": "privacy_policy_ul2_3",
  "privacy_policy_ul2_4": "privacy_policy_ul2_4",
  "privacy_policy_ul2_5": "privacy_policy_ul2_5",
  "privacy_policy_ul2_6": "privacy_policy_ul2_6",
  "privacy_policy_ul2_7": "privacy_policy_ul2_7",
  "privacy_policy_ul2_8": "privacy_policy_ul2_8",
  "privacy_policy_h3_4": "privacy_policy_h3_4",
  "privacy_policy_p5_1": "privacy_policy_p5_1",
  "privacy_policy_p5_2": "privacy_policy_p5_2",
  "privacy_policy_p5_3": "privacy_policy_p5_3",
  "privacy_policy_h3_5": "privacy_policy_h3_5",
  "privacy_policy_p6": "privacy_policy_p6",
  "privacy_policy_h3_6": "privacy_policy_h3_6",
  "privacy_policy_p7_1": "privacy_policy_p7_1",
  "privacy_policy_p7_2": "privacy_policy_p7_2",
  "privacy_policy_p7_3": "privacy_policy_p7_3",
  "privacy_policy_h3_7": "privacy_policy_h3_7",
  "privacy_policy_p8": "privacy_policy_p8",
  "privacy_policy_h3_8": "privacy_policy_h3_8",
  "privacy_policy_p9": "privacy_policy_p9",
  "privacy_policy_h3_9": "privacy_policy_h3_9",
  "privacy_policy_p10_1": "privacy_policy_p10_1",
  "privacy_policy_p10_2": "privacy_policy_p10_2",
  "privacy_policy_p10_3": "privacy_policy_p10_3",
  "attention": "attention",
  "are_you_over_18_years_old": "are_you_over_18_years_old",
  "yes_it_is_true": "yes_it_is_true",
  "not_it_is_not_true": "not_it_is_not_true",
  "anonymous_login": "anonymous_login",
  "login": "login",
  "forgot_a_password": "forgot_a_password",
  "login_as_invisible": "login_as_invisible",
  "your_gender": "your_gender",
  "choose_a_gender": "choose_a_gender",
  "email": "email",
  "not_receive_confirmation_email": "not_receive_confirmation_email",
  "send_email_one_more_time": "send_email_one_more_time",
  "or": "or",
  "enter": "enter",
  "cancel": "cancel",
  "enter_login": "enter_login",
  "only_for_18_years_old": "only_for_18_years_old",
  "understand": "understand",
  "confirmation_sent_successfully": "confirmation_sent_successfully",
  "you_are_blocked": "you_are_blocked",
  "you_need_to_wait": "you_need_to_wait",
  "update_available": "update_available",
  "reload": "reload",
  "too_much_attempts_for_entrance": "too_much_attempts_for_entrance",
  "add_telegram_username_to_block_title": "add_telegram_username_to_block_title",
  "add_telegram_username_to_block_explanation": "add_telegram_username_to_block_explanation",
  "telegram_username": "telegram_username",
  "telegram_username_successful_added": "telegram_username_successful_added",
  "telegram_username_added_error": "telegram_username_added_error",
  "ban_words_h1": "ban_words_h1",
  "ban_words_explanation": "ban_words_explanation",
  "blocked_word": "blocked_word",
  "add": "add",
  "edit": "edit",
  "delete": "delete",
  "user_for_block": "user_for_block",
  "select_reason_for_blocking": "select_reason_for_blocking",
  "block_for": "block_for",
  "why_we_are_blocking": "why_we_are_blocking",
  "block": "block",
  "user_for_deny_entry": "user_for_deny_entry",
  "reason_not_selected": "reason_not_selected",
  "chose_kick_reason": "chose_kick_reason",
  "kick_user_error": "kick_user_error",
  "gender_change": "gender_change",
  "to_change_gender": "to_change_gender",
  "gender_successfully_changed": "gender_successfully_changed",
  "about_me": "about_me",
  "avatar_presets_title": "avatar_presets_title",
  "avatar_upload_button": "avatar_upload_button",
  "avatar_upload_hint": "avatar_upload_hint",
  "avatar_upload_success": "avatar_upload_success",
  "avatar_upload_error": "avatar_upload_error",
  "avatar_remove_button": "avatar_remove_button",
  "avatar_premium_required": "avatar_premium_required",
  "avatar_token_rate_limited": "avatar_token_rate_limited",
  "avatar_invalid_hash": "avatar_invalid_hash",
  "avatar_rate_limited": "avatar_rate_limited",
  "password_change": "password_change",
  "password": "password",
  "new_password": "new_password",
  "repeat_new_password": "repeat_new_password",
  "to_change_password": "to_change_password",
  "password_successfully_changed": "password_successfully_changed",
  "balance": "balance",
  "make_payment": "make_payment",
  "your_balance_has_been_replenished_by": "your_balance_has_been_replenished_by",
  "has_been_debited_from_you": "has_been_debited_from_you",
  "delete_account": "delete_account",
  "cancel_delete_account": "cancel_delete_account",
  "delete_account_title": "delete_account_title",
  "delete_account_description": "delete_account_description",
  "yes_delete_my_account": "yes_delete_my_account",
  "application_for_delete_account_accepted": "application_for_delete_account_accepted",
  "application_for_delete_account_canceled": "application_for_delete_account_canceled",
  "cancel_delete_account_confirmation": "cancel_delete_account_confirmation",
  "yes_cancel_account_delete": "yes_cancel_account_delete",
  "no_delete_my_account": "no_delete_my_account",
  "your_account_will_deleted_via": "your_account_will_deleted_via",
  "unknown_error": "unknown_error",
  "add_word_to_block_list": "add_word_to_block_list",
  "add_telegram_username_to_block": "add_telegram_username_to_block",
  "add_remove_roles": "add_remove_roles",
  "moderator_section": "moderator_section",
  "sort_alphabet_asc": "sort_alphabet_asc",
  "sort_alphabet_dsc": "sort_alphabet_dsc",
  "sort_alphabet": "sort_alphabet",
  "sort_by_gender": "sort_by_gender",
  "sort_by_registered": "sort_by_registered",
  "sort_by_guests": "sort_by_guests",
  "sound_alerts_settings": "sound_alerts_settings",
  "users_list_sort": "users_list_sort",
  "log_in_log_out_messages": "log_in_log_out_messages",
  "add_watermark": "add_watermark",
  "show_images": "show_images",
  "images_display_section": "images_display_section",
  "images_display_chat": "images_display_chat",
  "images_display_external": "images_display_external",
  "external_images_warning_title": "external_images_warning_title",
  "external_images_warning_body": "external_images_warning_body",
  "external_images_warning_accept": "external_images_warning_accept",
  "external_images_warning_cancel": "external_images_warning_cancel",
  "dont_show_again": "dont_show_again",
  "disallow_private_messages": "disallow_private_messages",
  "settings": "settings",
  "enable_disable_autoscroll": "enable_disable_autoscroll",
  "you_dont_have_any_messages": "you_dont_have_any_messages",
  "chats_with_non_read_messages": "chats_with_non_read_messages",
  "show_hide_users_list": "show_hide_users_list",
  "file_too_large": "file_too_large",
  "cant_send_image": "cant_send_image",
  "cant_read_image_from_device": "cant_read_image_from_device",
  "your_complaint_has_been_accepted": "your_complaint_has_been_accepted",
  "you_cent_send_message_tou_yourself": "you_cent_send_message_tou_yourself",
  "you_cant_send_private_messages_in_invisible_mode": "you_cant_send_private_messages_in_invisible_mode",
  "your_login_example": "your_login_example",
  "notifications_in_lobby": "notifications_in_lobby",
  "notifications_in_other_rooms": "notifications_in_other_rooms",
  "notifications_in_private_messages": "notifications_in_private_messages",
  "notifications_on_replays": "notifications_on_replays",
  "user_offline_cant_send_message": "user_offline_cant_send_message",
  "close_room_title": "close_room_title",
  "close_reason": "close_reason",
  "block_room_creator": "block_room_creator",
  "block_room_members": "block_room_members",
  "please_use_this_very_carefully": "please_use_this_very_carefully",
  "to_block_room_creator_phrase_1": "to_block_room_creator_phrase_1",
  "to_block_room_creator_phrase_2": "to_block_room_creator_phrase_2",
  "to_block_room_creator_phrase_3": "to_block_room_creator_phrase_3",
  "why_room_is_closing": "why_room_is_closing",
  "close_the_room": "close_the_room",
  "close_room_confirmation_message": "close_room_confirmation_message",
  "room_closed": "room_closed",
  "about_room": "about_room",
  "info_about_room": "info_about_room",
  "creator_colon": "creator_colon",
  "moderators_colon": "moderators_colon",
  "description_colon": "description_colon",
  "chose_blocking_time": "chose_blocking_time",
  "report": "report",
  "report_reason_child_port_zoo": "report_reason_child_port_zoo",
  "report_reason_member_under_18_yo": "report_reason_member_under_18_yo",
  "report_reason_spam": "report_reason_spam",
  "report_reason_commerce": "report_reason_commerce",
  "report_men_in_room_for_women": "report_men_in_room_for_women",
  "creating_room": "creating_room",
  "room_title": "room_title",
  "fill_in_room_title": "fill_in_room_title",
  "room_title_too_short": "room_title_too_short",
  "room_title_too_long": "room_title_too_long",
  "room_title_should_start_from_eng_or_rus_character": "room_title_should_start_from_eng_or_rus_character",
  "password_if_you_want": "password_if_you_want",
  "password_too_long": "password_too_long",
  "password_too_short": "password_too_short",
  "additional_parameters_for_room_creation": "additional_parameters_for_room_creation",
  "paid_room": "paid_room",
  "paid_room_price": "paid_room_price",
  "paid_room_description": "paid_room_description",
  "paid_room_details": "paid_room_details",
  "paid_room_settings": "paid_room_settings",
  "unpaid_room_warning": "unpaid_room_warning",
  "low_balance_upcoming_charge_warning": "low_balance_upcoming_charge_warning",
  "deposit_money": "deposit_money",
  "add_moderator": "add_moderator",
  "remove_moderator": "remove_moderator",
  "only_premium_can_be_moderator": "only_premium_can_be_moderator",
  "user_not_a_room_moderator": "user_not_a_room_moderator",
  "user_name_should_be_entered_in_full": "user_name_should_be_entered_in_full",
  "moderator_role_has_been_successfully_assigned": "moderator_role_has_been_successfully_assigned",
  "moderator_role_has_been_successfully_took_off": "moderator_role_has_been_successfully_took_off",
  "edit_pinned_message": "edit_pinned_message",
  "editing_pinned_message": "editing_pinned_message",
  "allowed_tags": "allowed_tags",
  "preview": "preview",
  "changes_successfully_applied": "changes_successfully_applied",
  "change": "change",
  "assign": "assign",
  "take_off": "take_off",
  "user_not_found": "user_not_found",
  "user_not_premium": "user_not_premium",
  "user_banned": "user_banned",
  "user_already_moderator": "user_already_moderator",
  "allowed_only_to_registered": "allowed_only_to_registered",
  "allowed_only_to_registered_error": "allowed_only_to_registered_error",
  "which_gender_can_enter_into_room": "which_gender_can_enter_into_room",
  "choose_who_can_enter_into_room": "choose_who_can_enter_into_room",
  "create_room_attention": "create_room_attention",
  "create": "create",
  "warning": "warning",
  "loosed_connection_with_server": "loosed_connection_with_server",
  "enter_again": "enter_again",
  "message": "message",
  "type_in_message": "type_in_message",
  "send_message": "send_message",
  "send_image": "send_image",
  "show_hide_emoji": "show_hide_emoji",
  "answer": "answer",
  "block_user": "block_user",
  "block_user_commerce": "block_user_commerce",
  "block_user_child_porn": "block_user_child_porn",
  "block_user_age": "block_user_age",
  "deny_entry": "deny_entry",
  "remove_message": "remove_message",
  "private_message": "private_message",
  "ignore": "ignore",
  "not_ignore": "not_ignore",
  "load_image_error": "load_image_error",
  "login_for_search": "login_for_search",
  "enter_login_for_search": "enter_login_for_search",
  "find": "find",
  "user": "user",
  "roles": "roles",
  "administrator": "administrator",
  "role_admin_description": "role_admin_description",
  "moderator": "moderator",
  "role_moderator_description": "role_moderator_description",
  "save": "save",
  "failed_to_find_anybody": "failed_to_find_anybody",
  "something_goes_wrong_try_later": "something_goes_wrong_try_later",
  "roles_changed": "roles_changed",
  "for_room_entering_need_password_title": "for_room_entering_need_password_title",
  "fill_in_a_password_for_room_entrance": "fill_in_a_password_for_room_entrance",
  "search": "search",
  "clear_search_field": "clear_search_field",
  "rooms": "rooms",
  "create_room": "create_room",
  "users": "users",
  "error_connect": "error_connect",
  "error_server": "error_server",
  "wrong_gender": "wrong_gender",
  "login_too_short": "login_too_short",
  "login_is_used": "login_is_used",
  "spaces_not_allowed_in_login": "spaces_not_allowed_in_login",
  "you_are_bot": "you_are_bot",
  "error_en_ru_chars_together": "error_en_ru_chars_together",
  "error_vpn_used": "error_vpn_used",
  "email_is_busy": "email_is_busy",
  "email_or_code_is_wrong": "email_or_code_is_wrong",
  "restore_data_is_wrong": "restore_data_is_wrong",
  "restore_code_link_expire": "restore_code_link_expire",
  "delay_before_confirmation_send": "delay_before_confirmation_send",
  "unknown_user_or_email_confirmed": "unknown_user_or_email_confirmed",
  "email_not_confirmed": "email_not_confirmed",
  "delay_before_restoration_send": "delay_before_restoration_send",
  "user_is_blocked": "user_is_blocked",
  "login_too_long": "login_too_long",
  "message_to_long": "message_to_long",
  "email_incorrect": "email_incorrect",
  "incorrect_symbols_in_login": "incorrect_symbols_in_login",
  "other_incorrect_symbols_in_login": "other_incorrect_symbols_in_login",
  "passwords_not_equals": "passwords_not_equals",
  "emails_not_equals": "emails_not_equals",
  "too_many_attempts_to_change_password": "too_many_attempts_to_change_password",
  "gender_was_changed_recently": "gender_was_changed_recently",
  "no_privileges": "no_privileges",
  "room_creating_only_for_registered": "room_creating_only_for_registered",
  "you_have_created_too_many_rooms": "you_have_created_too_many_rooms",
  "not_enough_money": "not_enough_money",
  "room_not_paid": "room_not_paid",
  "room_with_name_already_exist": "room_with_name_already_exist",
  "complain": "complain",
  "room_responsibility_title": "room_responsibility_title",
  "room_responsibility_text": "room_responsibility_text",
  "room_responsibility_confirm": "room_responsibility_confirm",
  "room_responsibility_exit": "room_responsibility_exit",
  "complaint_reason_child_port_zoo": "complaint_reason_child_port_zoo",
  "complaint_reason_member_under_18_yo": "complaint_reason_member_under_18_yo",
  "complaint_reason_spam": "complaint_reason_spam",
  "complaint_reason_commerce": "complaint_reason_commerce",
  "men_in_room_for_women": "men_in_room_for_women",
  "message_blocked": "message_blocked",
  "to_many_messages": "to_many_messages",
  "to_many_images_in_main_chat": "to_many_images_in_main_chat",
  "not_enough_time_after_login": "not_enough_time_after_login",
  "user_block_error_first_part": "user_block_error_first_part",
  "block_error_reason_user_not_found": "block_error_reason_user_not_found",
  "block_error_reason_user_bot_or_admin": "block_error_reason_user_bot_or_admin",
  "block_error_reason_unknown_reason": "block_error_reason_unknown_reason",
  "block_error_reason_you_dont_have_permissions": "block_error_reason_you_dont_have_permissions",
  "block_error_reason_user_already_warned": "block_error_reason_user_already_warned",
  "user_blocked": "user_blocked",
  "user_warned": "user_warned",
  "gender_cant_enter_to_room": "gender_cant_enter_to_room",
  "cant_enter_gender_girls": "cant_enter_gender_girls",
  "cant_enter_gender_boys": "cant_enter_gender_boys",
  "cant_enter_gender_trans": "cant_enter_gender_trans",
  "blocked_users_list": "blocked_users_list",
  "manage_ban_reasons": "manage_ban_reasons",
  "theme_section": "theme_section",
  "theme_light": "theme_light",
  "theme_dark": "theme_dark",
  "theme_system": "theme_system",
  "add_new_reason": "add_new_reason",
  "remove_messages": "remove_messages",
  "no_ban_reasons_configured": "no_ban_reasons_configured",
  "title": "title",
  "description": "description",
  "blocking_time": "blocking_time",
  "remove_user_messages": "remove_user_messages",
  "failed_to_load_ban_reasons": "failed_to_load_ban_reasons",
  "error_loading_ban_reasons": "error_loading_ban_reasons",
  "title_is_required": "title_is_required",
  "blocking_time_hint": "blocking_time_hint",
  "please_check_form_errors": "please_check_form_errors",
  "ban_reason_saved_successfully": "ban_reason_saved_successfully",
  "failed_to_save_ban_reason": "failed_to_save_ban_reason",
  "error_saving_ban_reason": "error_saving_ban_reason",
  "ban_reason_deleted_successfully": "ban_reason_deleted_successfully",
  "error_deleting_ban_reason": "error_deleting_ban_reason",
  "confirm_delete_ban_reason": "confirm_delete_ban_reason",
  "unblock_user": "unblock_user",
  "login_fro_unblock": "login_fro_unblock",
  "unblock": "unblock",
  "user_unblocked": "user_unblocked",
  "blocked_users": "blocked_users",
  "transactions": "transactions",
  "no_transactions_found": "no_transactions_found",
  "date": "date",
  "failed_to_load_transactions": "failed_to_load_transactions",
  "filter_by_username": "filter_by_username",
  "reason": "reason",
  "will_be_unblocked": "will_be_unblocked",
  "permanently_banned_users_not_shown": "permanently_banned_users_not_shown",
  "connection_restored_after_disconnection": "connection_restored_after_disconnection",
  "user_disallow_private_messages": "user_disallow_private_messages",
  "you_disallow_private_messages": "you_disallow_private_messages",
  "moderator_cant_disable_private_messages": "moderator_cant_disable_private_messages",
  "too_many_registrations_from_ip": "too_many_registrations_from_ip",
  "kicked_from_room": "kicked_from_room",
  "kicked_from_room_error": "kicked_from_room_error",
  "nothing_found": "nothing_found",
  "would_you_like_to_send_an_image_to_chat": "would_you_like_to_send_an_image_to_chat",
  "yes_send": "yes_send",
  "chat_moderators": "chat_moderators",
  "managing_moderators": "managing_moderators",
  "permissions_count": "permissions_count",
  "permission_add_remove_moderators": "permission_add_remove_moderators",
  "permission_edit_pinned_message": "permission_edit_pinned_message",
  "permission_edit_ban_reasons": "permission_edit_ban_reasons",
  "permission_unblock_users": "permission_unblock_users",
  "permission_edit_room_password": "permission_edit_room_password",
  "room_password": "room_password",
  "new_room_password": "new_room_password",
  "set_room_password": "set_room_password",
  "remove_room_password": "remove_room_password",
  "room_password_hint": "room_password_hint",
  "room_password_changed": "room_password_changed",
  "room_password_removed": "room_password_removed",
  "permission_admin": "permission_admin",
  "permission_moderator": "permission_moderator",
  "no_moderators_found": "no_moderators_found",
  "moderator_permissions_updated": "moderator_permissions_updated",
  "error_updating_permissions": "error_updating_permissions",
  "moderator_removed_successfully": "moderator_removed_successfully",
  "error_removing_moderator": "error_removing_moderator",
  "confirm_remove_moderator": "confirm_remove_moderator",
  "username": "username",
  "select_permissions": "select_permissions",
  "username_required": "username_required",
  "exit": "exit",
  "exit_prompt": "exit_prompt",
  "exit_yes": "exit_yes",
  "yes": "yes",
  "no": "no",
  "lobby_room": "lobby_room",
  "admins_room": "admins_room",
  "block_list_room": "block_list_room",
  "amount_is_to_small": "amount_is_to_small",
  "amount_is_to_high": "amount_is_to_high",
  "payment_initialization_error": "payment_initialization_error",
  "payment_error": "payment_error",
  "service_phrases": {
    "enter": {
      "male": "service_phrases.enter.male",
      "female": "service_phrases.enter.female"
    },
    "exit": {
      "male": "service_phrases.exit.male",
      "female": "service_phrases.exit.female"
    }
  },
  "ok": "ok",
  "sex": {
    "female": "sex.female",
    "male": "sex.male",
    "trans": "sex.trans",
    "girls": "sex.girls",
    "boys": "sex.boys",
    "shemales": "sex.shemales"
  },
  "days": {
    "zero": "days.zero",
    "one": "days.one",
    "two": "days.two",
    "few": "days.few",
    "many": "days.many",
    "other": "days.other"
  },
  "hours": {
    "zero": "hours.zero",
    "one": "hours.one",
    "two": "hours.two",
    "few": "hours.few",
    "many": "hours.many",
    "other": "hours.other"
  },
  "minutes": {
    "zero": "minutes.zero",
    "one": "minutes.one",
    "two": "minutes.two",
    "few": "minutes.few",
    "many": "minutes.many",
    "other": "minutes.other"
  },
  "seconds": {
    "zero": "seconds.zero",
    "one": "seconds.one",
    "two": "seconds.two",
    "few": "seconds.few",
    "many": "seconds.many",
    "other": "seconds.other"
  },
  "blog_title": "blog_title",
  "back_to_blog": "back_to_blog",
  "make_payment_dialog_title": "make_payment_dialog_title",
  "amount_label": "amount_label",
  "placeholder_example": "placeholder_example",
  "hint_min_max": "hint_min_max",
  "error_required": "error_required",
  "error_integer": "error_integer",
  "error_min": "error_min",
  "error_max": "error_max",
  "pay": "pay",
  "pay_with_telegram_stars": "pay_with_telegram_stars",
  "pay_with_crypto": "pay_with_crypto",
  "choose_payment_method": "choose_payment_method",
  "back": "back",
  "choose_telegram_stars_package": "choose_telegram_stars_package",
  "telegram_stars_package_option": "telegram_stars_package_option",
  "telegram_stars_opening_bot": "telegram_stars_opening_bot",
  "telegram_package_not_found": "telegram_package_not_found",
  "telegram_only_for_registered": "telegram_only_for_registered",
  "telegram_stars_disabled": "telegram_stars_disabled",
  "premium": "premium",
  "buy_premium": "buy_premium",
  "premium_benefits": "premium_benefits",
  "premium_benefit_1": "premium_benefit_1",
  "premium_benefit_2": "premium_benefit_2",
  "premium_benefit_3": "premium_benefit_3",
  "premium_benefit_4": "premium_benefit_4",
  "premium_benefit_5": "premium_benefit_5",
  "premium_benefit_6": "premium_benefit_6",
  "premium_benefit_7": "premium_benefit_7",
  "premium_benefit_8": "premium_benefit_8",
  "premium_price_for_month": "premium_price_for_month",
  "buy_now": "buy_now",
  "premium_purchased_success": "premium_purchased_success",
  "buy_premium_disabled": "buy_premium_disabled",
  "premium_only_for_registered": "premium_only_for_registered",
  "premium_until": "premium_until",
  "your_premium_active_until": "your_premium_active_until",
  "extend_premium": "extend_premium",
  "boost_in_users_list": "boost_in_users_list",
  "premium_only_feature": "premium_only_feature",
  "premium_upsell_reminder": "premium_upsell_reminder",
  "disable_private_messages": "disable_private_messages"
}